let slickDefaults = require('../slick-default/slick-default');
let debounce = require('../../modules/debounce');
require('./benefits.less');

let size = require('../../modules/size');

jQuery(function($) {
    function setSlickBenefits() {
        $('.js-slick-benefits').each(function() {
            var $benefitsSlider = $(this);

            if (!$benefitsSlider.hasClass('slick-initialized')) {
                $benefitsSlider.slick(
                    $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
                        slidesToShow: 4,
                        adaptiveHeight: false,
                        responsive: [
                            {
                                breakpoint: size.desktop,
                                settings: { slidesToShow: 2 }
                            },
                            {
                                breakpoint: size.tablet,
                                settings: { slidesToShow: 1 }
                            }
                        ]
                    })
                );
            }
        });
    }
    setSlickBenefits();

    debounce.setResizeDebounce(setSlickBenefits);
});



// WEBPACK FOOTER //
// ./blocks/benefits/benefits.js